const toast = (store) => (next) => async action => {
  if (action.type === "error") console.log("Toastify", action.payload.message);
  else next(action);
};

export default toast;
